import Backbone from 'backbone';
import Shipment from './shipment';
var ShipmentCollection = Backbone.Collection.extend({
    model: Shipment,
    idAttribute: '_id',
});
export default ShipmentCollection;
